module.exports = __webpack_public_path__ + "assets/guojisanjian.d6461f19.svg";